<div class="columns small-12 medium-6" data-masonry-item="">
  <mprd-wifi-credentials-skeleton *ngIf="isPending"></mprd-wifi-credentials-skeleton>
  <div *ngIf="!isPending && !hasError" class="panel rs-bg-grey1 clearfix">
    <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
      {{ 'internet.wifiCredentials.title' | translate }}
    </h3>
    <div class="rs-form-item">
      <input
        type="text"
        class="rs-filled"
        readonly=""
        [id]="'ac-input-' + wifi.ssid"
        [value]="wifi.ssid"
        data-cy="wifiCredentialsSSID"
      />
      <label class="rs-form-label" [for]="'ac-input-' + wifi.ssid">{{
        'internet.wifiCredentials.ssid' | translate
      }}</label>
    </div>
    <div class="rs-form-item">
      <input
        pattern="[a-zA-Z0-9]+"
        placeholder="Placeholder"
        class="rs-filled"
        readonly=""
        [id]="'ac-password-' + wifi.ssid"
        [value]="wifi.password"
        [type]="showPassword ? 'text' : 'password'"
        data-cy="wifiCredentialsPassword"
      />
      <span
        class="jsrs-togglePassword rs-see-pwd"
        aria-label="See or hide password"
        role="button"
        tabindex="0"
        (click)="showPassword = !showPassword"
        [ngClass]="{ 'jsrs-togglePassword rs-see-pwd': true, 'rs-active': showPassword }"
        data-cy="wifiCredentialsIconPassword"
      ></span>
      <label class="rs-form-label" [for]="'ac-password-' + wifi.ssid">{{
        'internet.wifiCredentials.password' | translate
      }}</label>
    </div>
    <div class="medium-text-right">
      <a
        class="rs-btn rs-btn-third"
        data-cy="wifiCredentialsLink"
        (click)="goToEditWifiSetting()"
        data-tms-event="button-click"
        data-tms-button-zone="internet options"
        data-tms-button-name="Manage Wi-Fi"
        >{{ 'internet.wifiCredentials.editWifiSetting.label' | translate
        }}<i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
      ></a>
    </div>
  </div>

  <px-alert
    *ngIf="hasError"
    [alerts]="[
      {
        type: 'error',
        description: 'internet.wifiCredentials.error.message' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]"
  ></px-alert>
</div>
